/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Console_Copy_LanguageInputs */

const en_console_copy_language = /** @type {(inputs: Console_Copy_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copy ${i?.language}`)
};

const zh_hans1_console_copy_language = /** @type {(inputs: Console_Copy_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`复制 ${i?.language}`)
};

const pt_br2_console_copy_language = /** @type {(inputs: Console_Copy_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copiar ${i?.language}`)
};

const es_console_copy_language = /** @type {(inputs: Console_Copy_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copiar ${i?.language}`)
};

const fr_console_copy_language = /** @type {(inputs: Console_Copy_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copier ${i?.language}`)
};

const de_console_copy_language = /** @type {(inputs: Console_Copy_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.language} kopieren`)
};

const ru_console_copy_language = /** @type {(inputs: Console_Copy_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Скопировать ${i?.language}`)
};

const it_console_copy_language = /** @type {(inputs: Console_Copy_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copia ${i?.language}`)
};

/**
* | output |
* | --- |
* | "Copy {language}" |
*
* @param {Console_Copy_LanguageInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_copy_language = /** @type {((inputs: Console_Copy_LanguageInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Copy_LanguageInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_copy_language(inputs)
	if (locale === "pt-BR") return pt_br2_console_copy_language(inputs)
	if (locale === "es") return es_console_copy_language(inputs)
	if (locale === "fr") return fr_console_copy_language(inputs)
	if (locale === "de") return de_console_copy_language(inputs)
	if (locale === "ru") return ru_console_copy_language(inputs)
	if (locale === "it") return it_console_copy_language(inputs)
	return en_console_copy_language(inputs)
});